module.exports = __webpack_public_path__ + "toBride2-we-p-w.b52eb28f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-p-w.jpg
// module id = rLND
// module chunks = 0